/**
 * `facility_id` = the trailer's current facility; `destination_facility_id` only when
 * the destination is another campus facility, so same-facility payloads are unchanged.
 */
export function withCampusFacilities<T extends Record<string, any>>(
  variables: T,
  sourceFacilityId: string | number,
  destinationFacilityId?: string | number | null
): T & { facility_id: string; destination_facility_id?: string } {
  const source = String(sourceFacilityId);
  const result: T & { facility_id: string; destination_facility_id?: string } = {
    ...variables,
    facility_id: source
  };

  if (destinationFacilityId !== undefined && destinationFacilityId !== null) {
    const destination = String(destinationFacilityId);
    if (destination !== '' && destination !== source) {
      result.destination_facility_id = destination;
    }
  }

  return result;
}

/** Ties a move to the yard check it was made during. */
export interface YardCheckContext {
  run_uuid?: string;
  facility_zone_uuid?: string;
}

/**
 * The yard check a move is made during, sent with it so the server can tell a
 * move made while checking the yard from an ordinary one. `null` outside a check.
 * `run_uuid` is absent for a check started before runs existed.
 */
export function yardCheckContext(
  isYardCheckMode: boolean,
  checkedZoneId: string | null,
  runUuid?: string | null
): YardCheckContext | null {
  if (!isYardCheckMode || !checkedZoneId) {
    return null;
  }

  const context: YardCheckContext = { facility_zone_uuid: checkedZoneId };
  if (runUuid) {
    context.run_uuid = runUuid;
  }

  return context;
}
